import React from 'react';
import { Popup } from 'witmeg-ui-system';
import "./Popup.scss"
import cart from "../../assets/cart-white.svg"
import close from "../../assets/close-gray.svg"
import IMAGE_PLACEHOLDER from "../../assets/images/Images/vouchers-placeholder.jpg"
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from '../../../../../utilities/helper';
import { useSelector } from 'react-redux';

const PreviewPopup = ({ visibility, onAdd, onPopupClose, isLoading }) => {
    const voucher = visibility
    const { currency,
    } = useSelector((state) => state.resturantData);
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const currencyFormat = getCurrencyFormat(currency);
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    console.log(voucher, "voucher")
    return (
        <Popup
            className='Preview-voucher'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={onPopupClose}
            closable={false}>
            <div className='popup-inner'>
                <div className='popup-inner-header'>
                    Voucher Preview
                    {/* <img alt='' src={close}
                        onClick={() => {
                            onPopupClose()
                        }} /> */}
                </div>
                <div className='popup-inner-details'>
                    <img alt="" src={voucher?.ImageURL ? voucher.ImageURL : IMAGE_PLACEHOLDER}
                        className="item-image"
                    />
                    <div className='voucher-name'>{voucher?.Title?.en?.toCapitalFirst()}</div>
                    <div className='voucher-value'>Value: {getThePrice(voucher?.PriceInfo?.Price)}</div>

                </div>
                <div className='popup-inner-btnCont'>
                    <div className='add-btn-conatiner' onClick={onAdd}>
                        {isLoading ? <div className='loader-btn' /> : <img alt='' src={cart} />}
                        Add to Cart - {getThePrice(voucher?.PriceInfo?.Price)}
                    </div>
                    <div className='cancel-btn-conatiner' onClick={onPopupClose}>
                        Close
                    </div>
                </div>

            </div>
        </Popup>
    );
}

export default PreviewPopup;